// libs
import get from 'lodash/get';

type IProductTypes = 'configurable' | 'simple' | 'tiptile';
// defs
interface IItem {
  backorders: boolean;
  brandIds: string;
  categoryIds: string;
  configurableType: string;
  discount: number;
  finalPrice: number;
  imageUrl: string;
  isLux: boolean;
  isSaleable: null;
  lux: boolean;
  mrp: number;
  name: string;
  offersCount: number;
  optionsCount: number;
  packSize: string;
  productId: string;
  rating: number;
  ratingCount: number;
  saleable: null;
  sku: string;
  slug: string;
  type: IProductTypes;
  brandName: string[];
  inStock: boolean;
}

interface Response {
  data: {
    bucket: string;
    created: string;
    customerId: number;
    items: IItem[];
    itemsCount: number;
    itemsQuantity: number;
    updated: string;
  };
  message: string;
  requestProtocol: any;
  responseProtocol: any;
  statusCode: string;
  success: boolean;
  userTrackingId: any;
}

export const transformProducts = (res: Response) => {
  const items = get(res, 'data.items', []);

  let wishlistProducts: Listing.IProduct[] = [];
  for (var item in items) {
    let product: Listing.IProduct;
    product = {
      ...items[item],
      actionUrl: `${get(items[item], 'slug', '')}`,
      id: get(items[item], 'productId', ''),
      isOutOfStock: !get(items[item], 'inStock', true),
      subTitle: get(items[item], 'name', ''),
      title: get(items[item], 'brandName[0]', ''),
      price: get(items[item], 'mrp'),
      discountedPrice: get(items[item], 'finalPrice'),
    };
    wishlistProducts.push(product);
  }

  return wishlistProducts;
};
